<template>
  <div class="top-bar" :class="isSingle && 'single-top-bar'">
    <div class="level1">
      <div id="logo" class="logo"></div>
      <div id="firm_version" class="firm_version">
        {{ $t("router_firmware_version") }}
        <span> {{ $store.state.user.firm_version }} </span>
      </div>
    </div>
    <div v-if="$store.state.page.type == 'orbi' && !isSingle" class="logout-div">
      <el-button id="logout" @click="logout">{{ $t("logout_head") }}</el-button>
    </div>
    <div v-if="$store.state.page.type == 'router' && !isSingle" class="level2">
      <div id="router_name" class="router_name">
        <b>{{ $t("my_router") }}:</b>
        <span>{{ $store.state.user.hardware_verion }}</span>
      </div>
      <lang-selection ref="lang" class="right-lang" />
    </div>
    <div v-if="!isSingle" class="level3">
      <el-menu
        :default-active="$store.state.page.topSelectedMenu"
        router
        class="el-menu-top"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item
          v-for="item in menu"
          :key="item.path"
          :index="item.path"
          :disabled="$store.state.user.menu_disabled"
        >
          <span :id="item.id">{{ $t(item.meta.title) }}</span>
        </el-menu-item>
      </el-menu>
      <div
        id="update_info"
        v-if="!$store.state.user.menu_disabled && $store.state.user.has_new_version"
        class="new-version-note"
        @click="firmwareUpgrade"
      >
        {{ $t("firmware_upgrade_is_available_click_to_get") }}
      </div>
      <div v-if="$store.state.page.type == 'orbi'" class="lang-div">
        <lang-selection ref="lang" class="right-lang" />
      </div>
    </div>
  </div>
</template>
<script>
import LangSelection from "@/components/header/langSelection";
export default {
  components: { LangSelection },
  props: {
    menu: {
      type: Array,
      default() {
        return [];
      },
    },
    isSingle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showLogout: false,
    };
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
    },
    handleSelect(key) {
      if (!this.isSingle) {
        this.$store.dispatch("page/setTopMenu", key);
        this.$emit("click_top_menu", key);
      }
    },
    logout() {
      this.$router.push({ path: "/logout" });
    },
    firmwareUpgrade() {
      if (this.$store.state.page.type == "orbi") {
        if (this.$store.state.user.menu_disabled || this.$route.path == "/adv/admin/orbiUpgrade") {
          return;
        }
        localStorage.setItem("upgrageFlag", "check");
        this.utils.routerPush("/adv/admin/orbiUpgrade");
      } else {
        if (this.$store.state.user.menu_disabled || this.$route.path == "/adv/admin/upgrade") {
          return;
        }
        localStorage.setItem("upgrageFlag", "check");
        this.utils.routerPush("/adv/admin/upgrade");
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.top-bar {
  height: $toBarHeight;
  width: 100%;
  line-height: $toBarHeight;
  position: absolute;
  vertical-align: middle;
  top: 0;
  left: 0;
  background: #fff;
  // border-bottom: $frameBorderWidth solid $frameBorderColor;
  min-width: $pageMiniWidth;
}
.top-bar.single-top-bar {
  height: 90px;
  border-bottom: none;
}
.logo {
  background: url("~images/top_bar/basic-logo.png") no-repeat;
  background-size: 100% 100%;
  width: $logoWidth;
  height: $logoHeight;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 24px;
  float: left;
}
.right-top-btns {
  float: right;
  margin-right: 20px;
}
.right-top-btns i {
  font-size: $topBarFontSize;
  line-height: $toBarHeight;
}
.right-top-btns .el-divider {
  margin-left: 10px;
  margin-right: 0;
}
.right-top-btns > i {
  margin-left: 8px;
}

.el-badge {
  line-height: 24px;
  margin-right: 5px;
  i {
    margin: 0;
  }
  i,
  sup {
    line-height: auto;
  }
}
.right-top-btns {
  li {
    float: left;
    margin-left: 26px;
    float: left;
    position: relative;
    list-style: none;
  }
  margin-top: 36px;
  .btn {
    width: 27px;
    height: 27px;
  }

  .box {
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 #000;
    padding: 5px 15px;
    background: #fff;
  }

  .el-link {
    margin: 7px 0;
    color: $formLabelColor;
    letter-spacing: 0.1px;
    line-height: 19px;
    width: 100%;
    text-align: left;
    display: block;
  }
  .el-link.el-link--default:hover {
    color: $formLabelColor;
    text-decoration: underline;
  }
  .el-link.is-underline:hover:after {
    display: none;
  }
}
.level1 {
  height: $level1Height - $level1BorderHeight;
  width: 100%;
  background: $leve11BgColor;
  color: #fff;
  border-bottom: solid $level1BorderHeight $level1BorderColor;
  line-height: 24px;
  .firm_version {
    color: $level1FontColor;
    position: absolute;
    left: 20px;
    top: 68px;
    font-size: 14px;
  }
}
.level2 {
  width: calc(100% - 40px);
  height: $level2Height - $level2BorderHeight;
  line-height: $level2Height - $level2BorderHeight;
  margin-left: 20px;
  border-bottom: $level2BorderColor solid $level2BorderHeight;
  display: -webkit-flex;
  display: flex;
  .router_name {
    font-size: 14px;
    color: #2c262d;
    width: 100%;
  }
  .right-lang {
    float: right;
  }
}
.level3 {
  display: block;
  float: left;
  height: $topMenuHeight;
  position: absolute;
  top: $toBarHeight - $level3Height;
  left: 20px;
  right: 20px;
  .el-menu-top {
    // border: 0 none !important;
    .el-menu-item.is-disabled,
    .el-menu-item {
      opacity: 1;
      height: $topMenuHeight;
      line-height: $topMenuHeight - 3px;
      border: solid 1px $topMenuInactiveBorderColor;
      border-bottom: 0 none;
      border-radius: 5px 5px 0 0;
      color: $topMenuInactiveColor;
      background: $topMenuInactiveBgColor !important;
      font-size: $topMenuFontSize;
      font-weight: $topMenuFontWeight;
      text-transform: uppercase;
    }
    .el-menu-item.is-active.is-disabled,
    .el-menu-item.is-active {
      opacity: 1;
      border-bottom: 0 none;
      border-color: $topMenuActiveBorderColor;
      background: $topMenuActiveBgColor !important;
      color: $topMenuActiveColor !important;
    }
    .el-menu-item.is-active::after {
      content: " ";
      width: 100%;
      height: 1px;
      background: $topMenuActiveBgColor;
      position: absolute;
      left: 0;
      bottom: -1px;
      z-index: 2;
    }
    .el-menu-item:not(:first-child) {
      margin-left: 5px;
    }
    .el-menu-item.is-disabled:hover .el-menu-item:hover {
      color: $topMenuInactiveColor !important;
      background-color: $topMenuInactiveBgColor !important;
    }
    .el-menu-item:not(.is-active):hover {
      color: $topMenuInactiveHoverColor !important;
      background-color: $topMenuInactiveBgColor !important;
    }
    .el-menu-item.is-active.is-disabled:hover,
    .el-menu-item.is-active:hover {
      background-color: $topMenuActiveBgColor !important;
      color: $topMenuActiveColor;
    }
  }
  .el-menu::after {
    clear: none;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }
}
.level3::after {
  content: " ";
  height: $level3BorderHeight;
  background: $level3BgColor;
  position: absolute;
  top: $topMenuHeight;
  left: 0;
  width: 100%;
}
.new-version-note {
  cursor: pointer;
  background: $level3BorderColor;
  color: #fff;
  float: left;
  height: 25px;
  line-height: 25px;
  padding: 0 10px;
  border-radius: 5px;
  margin-left: 20px;
}

.orbi.gui-2-1 {
  .level1 {
    .logo {
      margin-top: 8px;
    }
    .firm_version {
      text-align: right;
      color: $level1FontColor;
      font-weight: bold;
      left: unset;
      right: 20px;
      top: 50px;
      line-height: 1;
      span {
        display: block;
      }
    }
  }
  .logout-div {
    position: absolute;
    top: 8px;
    right: 0;
    line-height: 1;
    .el-button {
      min-width: 100px;
      line-height: 1;
      height: 22px;
      border-radius: 10px;
    }
  }
  .level3 {
    .lang-div {
      position: absolute;
      right: 0;
      bottom: 5px;
      line-height: 1;
    }
  }
  .new-version-note {
    cursor: pointer;
    background: #836fff;
    color: #fff;
    float: left;
    height: 25px;
    line-height: 25px;
    padding: 0 10px;
    border-radius: 5px;
    margin-left: 20px;
  }
}
</style>
